import Page from '@/components/layout/Page'
import PageTitle from '@/components/ui/PageTitle'
import SectionTitle from '@/components/ui/SectionTitle'

export default {
  components: {
    Page,
    PageTitle,
    SectionTitle
  }
}



// WEBPACK FOOTER //
// ./src/mixins/pages/Page.js